import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const FORM_SERVICE_GROUP_CONTEXT_SYMBOL = Symbol();
const useFormServiceGroup = ()=>useImmutableContext(FORM_SERVICE_GROUP_CONTEXT_SYMBOL);
const useFormServiceGroupProvider = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return useImmutableContextProvider(FORM_SERVICE_GROUP_CONTEXT_SYMBOL, ...args);
};
export { useFormServiceGroup, useFormServiceGroupProvider };
